module.exports = __webpack_public_path__ + "static/media/26UNRWA6.d6bd2a5c.jpg";